import { render, staticRenderFns } from "./StatisticsProducts.vue?vue&type=template&id=6c02e3b8&scoped=true&"
import script from "./StatisticsProducts.vue?vue&type=script&lang=js&"
export * from "./StatisticsProducts.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsProducts.vue?vue&type=style&index=0&id=6c02e3b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c02e3b8",
  null
  
)

export default component.exports